export default __webpack_public_path__ + "static/media/auction.14a0130d.png";